/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import { useFetchPersonalPronounLabel } from 'hooks';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function NameLabel({ firstName, lastName, personalPronoun, fullName, delimiter, options }) {
  const classes = useStyles();
  const pronoun = useFetchPersonalPronounLabel(personalPronoun);
  const name = fullName || `${firstName} ${lastName}`;
  // eslint-disable-next-line react/no-unstable-nested-components
  function Name() {
    return <> {name && <span>{name}</span>}</>;
  }

  // eslint-disable-next-line react/no-unstable-nested-components
  function Pronoun() {
    return (
      pronoun && (
        <Tooltip title={pronoun}>
          <span className={options.pronoun.mutedText ? classes.pronoun : ''}>{options.pronoun.parentheses ? `(${pronoun})` : pronoun}</span>
        </Tooltip>
      )
    );
  }

  return (
    <>
      <Name />
      <Pronoun {...options.pronoun} />
      {delimiter && <span>{delimiter}</span>}
    </>
  );
}

NameLabel.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  personalPronoun: PropTypes.string,
  fullName: PropTypes.string,
  delimiter: PropTypes.string,
  options: PropTypes.shape({
    pronoun: PropTypes.shape({
      mutedText: PropTypes.bool,
      parentheses: PropTypes.bool,
    }),
  }),
};

NameLabel.defaultProps = {
  firstName: '',
  lastName: '',
  personalPronoun: '',
  fullName: '',
  delimiter: '',
  options: { pronoun: { mutedText: false, parentheses: false } },
};

export default NameLabel;
